import { withSvgIcon } from './withSvgIcon';

export const Copy = withSvgIcon(
  <>
    <rect
      x="9"
      y="9"
      width="10"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M7 14V14C5.89543 14 5 13.1046 5 12V7C5 5.89543 5.89543 5 7 5H12C13.1046 5 14 5.89543 14 7V7"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
